import React, { useEffect, useRef, useState } from "react";
import { useApp } from 'common/AppContext';
import { Alert, Container, Image, Spinner } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { FaCheckCircle, FaClock } from "react-icons/fa";
import { useSuperState } from 'helpers/hooks';
import FormattedDuration from 'react-intl-formatted-duration';
import { useHistory } from "react-router-dom";

import logo from "common/assets/logo_gmetrix.png";

const Queue = props => {

    const { api, setLocale } = useApp();
    const history = useHistory();

    const [state, setState, resetState] = useSuperState({
        loading: true,
        error: null,
        session: null,
        status: null,
        queue_rank: null,
        check_count: 0,
        seconds_waiting: 0
    });

    const queue_guid = props?.match?.params?.queue_guid;
    const { loading, error, session, status, queue_rank, check_count, seconds_waiting } = state;

    const getQueueItem = async () => {

        await api.get(`/api/appstream/queue/get/${queue_guid}`).then(({ item }) => {

            const { sms_ctag } = item;

            if (sms_ctag)
                setLocale(sms_ctag);

            setState({
                loading: false,
                item
            });

        }).catch(e => {

            console.error(e);

            setState({
                error: e?.err || e.toString()
            });

        });

    };

    const checkQueue = async () => {

        await api.get(`/api/appstream/queue/check/${queue_guid}`).then(({ session, status, queue_rank }) => {

            setState(prevState => ({
                ...prevState,
                session,
                status,
                queue_rank,
                check_count: prevState.check_count + 1
            }));

            // Start a timer to do the redirect
            if (session) {

                setTimeout(() => {

                    history.replace(`/player/${session?.session_guid}`);

                }, 2000);

            }

        }).catch(e => {

            console.error(e);

            setState({
                error: e?.err || e.toString()
            });

        });

    };

    useEffect(() => {

        let interval = null;
        let interval_counter = null;

        getQueueItem().then(() => {

            // 10 second interval to check queue position
            interval = setInterval(checkQueue, 10 * 1000);

            // 2 second delay to start the queue checking
            setTimeout(checkQueue, 2000);

            // 1 second timer to increment number of seconds waiting
            interval_counter = setInterval(() => { setState(prevState => { prevState.seconds_waiting = prevState.seconds_waiting + 1; return prevState; }); }, 1000);

        });

        // Kill the interval on unmount
        return () => {

            clearInterval(interval);
            clearInterval(interval_counter);

        };

    }, []);

    return (<>
        <div
            style={{
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                position: 'absolute',
                left: 0,
                top: 0,
                zIndex: 1
            }}>
            {loading &&
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden"><FormattedMessage id="label.loading" defaultMessage="Loading..."/></span>
                    </Spinner>
                </div>
            }
            {error && <Alert variant="warning">{error}</Alert>}
            {!loading && <>
                <Container
                    fluid
                    className="d-flex justify-content-center align-items-center min-vh-100"
                >
                    <div className="text-center" style={{ maxWidth: 375 }}>
                        <div>
                            <Image src={logo} width={200} className="mb-5"/>
                        </div>
                        {!session && <>
                            {check_count <= 2 &&
                                <>
                                    <div className="mb-5">
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden"><FormattedMessage id="label.loading" defaultMessage="Loading..."/></span>
                                        </Spinner>
                                    </div>
                                    <h5>
                                        <FormattedMessage id="label.please_wait_while_your_session_is.87e92bc4" defaultMessage="Please wait while your session is reserved"/>
                                    </h5>
                                </>
                            }
                            {check_count > 2 &&
                            <>
                                <p>
                                    <FormattedMessage id="label.we_are_experiencing_higher_volume.18cdab37" defaultMessage="We are experiencing higher volume than usual. Please be patient while we prepare your session, this may take up to 10 minutes"/>
                                </p>
                                <h5 className="mt-5">
                                    <FaClock size={35} className="text-secondary mb-3"/>
                                    <br/>
                                    <FormattedMessage id="label.you_have_been_waiting_for" defaultMessage="You have been waiting for"/>
                                    <br/>
                                    <small>
                                        <FormattedDuration seconds={seconds_waiting} unitDisplay="short" format="{minutes} {seconds}" />
                                    </small>
                                </h5>
                                <br/>
                            </>
                            }
                        </>}
                        {session && <>
                            <>
                                <div className="mb-5">
                                    <FaCheckCircle className="text-success" size={45}/>
                                </div>
                                <h5>
                                    <FormattedMessage id="label.your_session_has_been_reserved_red.bdd146af" defaultMessage="Your session has been reserved. Redirecting..."/>
                                </h5>
                            </>
                        </>}
                    </div>
                </Container>

            </>}
        </div>
    </>);

};

export default Queue;